<script setup lang="ts">
const emit = defineEmits(["close", "submitRevoke"]);
defineProps({
  offer: {
    type: Object as PropType<Offer>,
    required: true,
  },
});

const isLoading = ref(false);

const cancelListing = () => {
  isLoading.value = true;
  setTimeout(() => {
    emit("submitRevoke");
  }, 500);
};
</script>
<template>
  <div class="flex flex-col items-center gap-y-6 mt-8 mb-4">
    <img
      class="w-32 object-contain border border-secondary-500"
      :src="getPortraitItemImage(offer.imageId)"
      @error="
        (e) => ((e.target as HTMLImageElement).src = getPortraitItemImage())
      " />
    <i18n-t
      tag="p"
      class="text-neutral-300 text-center max-w-xs px-2"
      keypath="main.modalOffer.revokeOfferDetail"
      scope="global">
      <template #collectible>
        <span class="font-bold text-neutral-200">{{
          $t(`${offer.translationId}.title`) +
          " " +
          $t(`${offer.translationId}.subtitle`) +
          " #" +
          offer.collectibleNumber
        }}</span>
      </template>
    </i18n-t>
    <div class="w-full mt-auto mb-2 flex justify-center items-center gap-4">
      <BaseButtonSubmit
        :loading="isLoading"
        :text="$t('main.modalOffer.revokeOffer')"
        :disabled="isLoading"
        data-test="button-revoke-offer"
        :contextual-styles="true"
        @click="cancelListing" />
      <BaseButtonCancel
        :text="$t('main.modalOffer.cancel')"
        data-test="button-dismiss-revoke-offer"
        :contextual-styles="true"
        @click="$emit('close')" />
    </div>
  </div>
</template>
